import { render, staticRenderFns } from "./RadioList.vue?vue&type=template&id=7622a2b2&scoped=true&"
import script from "./RadioList.vue?vue&type=script&lang=js&"
export * from "./RadioList.vue?vue&type=script&lang=js&"
import style0 from "./RadioList.vue?vue&type=style&index=0&id=7622a2b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622a2b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7622a2b2')) {
      api.createRecord('7622a2b2', component.options)
    } else {
      api.reload('7622a2b2', component.options)
    }
    module.hot.accept("./RadioList.vue?vue&type=template&id=7622a2b2&scoped=true&", function () {
      api.rerender('7622a2b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/arrange/RadioList.vue"
export default component.exports